import React from 'react';
import styles from './Question.css';
import AllCollapseExample from '../AccordionQuestions/AccordionQuestion';



export default function Question() {
  return (
    <section className='qns-container'>
        <div className="question-container">
            <h3>Frequently Asked Question</h3>
            <p>Here are some of our FAQs. If you have any other questions you’d like answered please feel free to email us.</p>

            <div className="question-container-dropdown">
             <AllCollapseExample />
            </div>
        </div>
    </section>
  )
}
